<template>
  <bb-modal
    v-if="countdown !== null"
    center-vertically
    hide-close
    class="text-center"
    flavor="user"
    :class="{ 'session-expiration--loading': loading }"
    :visible="show"
  >
    <div class="color-blue f-gotham-bold">
      {{ title }}
    </div>
    <div v-if="!loading">
      <div class="h1 f-gotham-medium color-blue m-y-50">
        {{ countdown | toTime }}
      </div>
      <div
        v-if="description"
        class="f-gotham-medium f-smallest color-gray-90 m-b-50"
      >
        {{ description }}
      </div>
    </div>
    <div
      v-if="loading"
      class="d-flex justify-content-center p-y-40"
    >
      <bb-spinner />
    </div>
    <bb-button
      display="block"
      :disabled="loading"
      :label="buttonLabel"
      @click="continueCurrentSession"
    />
  </bb-modal>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import dayjs from 'dayjs';
  import { BbButton, BbModal, BbSpinner } from '@bigbank/interface-components';

  export default {
    name: 'session-expiration',

    filters: {
      toTime: value => {
        return dayjs().set('second', 0).set('minute', 0).add(value, 'second').format('mm:ss');
      },
    },

    components: {
      BbButton,
      BbModal,
      BbSpinner,
    },

    props: {
      buttonLabel: {
        type: String,
        required: true,
      },
      description: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        required: true,
      },
    },

    data () {
      return {
        remainingTime: 30,
        countdown: null,
        loading: false,
        show: false,
        interval: null,
        disableSessionExpirationOnPageLoad: false,
      };
    },

    computed: { ...mapGetters('sessionExpiration', ['secondsLeft']) },

    watch: {
      secondsLeft: {
        immediate: true,
        handler (value) {
          this.init(value);
        },
      },
      $route: {
        immediate: true,
        handler (to) {
          if (to.meta.disableSessionExpiration) {
            this.setSessionExpireDate(null);
          } else if (!this.interval) {
            this.init(this.secondsLeft);
          }
        },
      },
    },

    methods: {
      ...mapActions('sessionExpiration', [
        'setSessionExpireDate',
        'continueSession',
        'stopSession',
      ]),

      init (seconds) {
        if (this.interval) clearInterval(this.interval);
        if (typeof seconds === 'number' && !this.$route.meta.disableSessionExpiration) {
          this.countdown = seconds;
          this.startInterval();
        }
      },

      startInterval () {
        this.interval = setInterval(() => {
          this.countdown--;
          this.countdown <= 0 && this.stopCurrentSession();

          if (!this.show && this.countdown <= this.remainingTime) {
            this.show = true;
          }
        }, 1000);
      },

      continueCurrentSession () {
        this.callAction(this.continueSession);
      },

      stopCurrentSession () {
        this.callAction(this.stopSession);
      },

      async callAction (action) {
        this.loading = true;
        clearInterval(this.interval);
        await action();
        this.show = false;
        setTimeout(() => this.loading = false, 1000);
      },
    },
  };
</script>
